import React, { useEffect, useState } from "react";
import "../supplierAndManufacturers.scss";
import CheckItem from "./CheckItem";
import HighgroundDatePicker from "../../../test/TestComponent";
import CategoryOrSubcategoryDropdown from "./CategoryOrSubcategoryDropdown";
import HighlightInput from "./HighlightInput";
import { getAPIData } from "../../../../Utils/commonApi";
import { useAuth } from "../../../context/Auth";
import axios from "axios";
import useUserDetails from "../../../../hooks/user-details.hook";

const EditModalBody = ({ isFormPSA = false, modalData = {}, errors = {}, setErrors = () => { }, setModalData = () => { } }) => {
  const { authTokens } = useAuth();
  const uploadRef = React.useRef();
  const [categoriesList, setCategoriesList] = useState([]);
  const [subCategoriesList, setSubcategoriesList] = useState([]);
  const [uploadedImage, setUploadedImage] = useState();
  const { isSaaS } = useUserDetails();

  useEffect(() => {
    getCategories();
  }, []);

  async function getCategories() {
    await getAPIData(636, authTokens, {
      ...(isSaaS && {
        optionEnum99: 32
      })
    })
      .then((response) => {
        setCategoriesList(response?.TechnologySpendDetails_List);
      })
      .catch((err) => { });
  }

  async function getProductSubCategories(id) {
    await getAPIData(627, authTokens, { optionEnum1: id })
      .then((response) => {
        setSubcategoriesList(response?.TechnologySpendDetails_List);
      })
      .catch((err) => { });
  }

  const handleUpload = async (event) => {
    event.preventDefault();
    const file = event.target.files[0];

    const allowedFileTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "application/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "image/jpeg",
      "image/bmp",
      "image/png",
    ];

    if (file && allowedFileTypes.includes(file.type)) {
      const reader = new FileReader();

      reader.onloadend = async () => {
        const base64Data = reader.result;
        const formData = new FormData();
        formData.append("File", file);
        formData.append("FileName", file?.name);
        formData.append(
          "accessKey",
          JSON.parse(localStorage.getItem("user_MessageObj"))
        );

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/CC_API/UploadSupplierManufacturerFile`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${authTokens}`,
              },
              onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                // setUploadProgress(percentCompleted);
              },
            }
          );

          if (response) {
            setUploadedImage(response?.data);
            setModalData(prev => ({ ...prev, Icon: response?.data?.FileURL }));
          } else {
            console.error("Something went wrong");
          }

          // setUploadProgress(0);
        } catch (error) {
          console.error("Upload failed:", error);
        }
      };

      reader.readAsDataURL(file);
    } else {
      console.error("Invalid file type. Please upload a PDF, DOC, DOX, or TXT file.");
    }
  };

  return (
    <>
      <div className="bodyHeader">Details</div>
      <ModalItem
        label="Name"
        value={modalData?.Name}
        isError={errors?.Name}
        onChange={(value) => {
          setModalData(prev => ({ ...prev, Name: value ?? '' }))
          setErrors((prev) => ({ ...prev, Name: false }));
        }}
        disable={isFormPSA}
      />

      <ModalItem
        label="Type"
        children={<div className="w-100">
          <div className="d-flex align-items-center w-100 px-2">
            <CheckItem
              disable={isFormPSA}
              label='Supplier'
              value={modalData?.IsSupplier}
              onClick={(value) => {
                setModalData(prev => ({ ...prev, IsSupplier: value ?? false }))
                setErrors((prev) => ({ ...prev, Type: false }));
              }}
            />
            <div className="ml-4">
              <CheckItem
                disable={isFormPSA}
                label='Manufacturer'
                value={modalData?.IsManufacturer}
                onClick={(value) => {
                  setModalData(prev => ({ ...prev, IsManufacturer: value ?? false }))
                  setErrors((prev) => ({ ...prev, Type: false }));
                }}
              />
            </div>
          </div>
          {errors?.Type && (<div className="f-danger f-12">Type cannot be empty</div>)}
        </div>}
      />

      <ModalItem
        label="Contact email"
        value={modalData?.ContactEmail}
        isError={errors?.ContactEmail}
        onChange={(value) => {
          setModalData(prev => ({ ...prev, ContactEmail: value ?? '' }))
          setErrors((prev) => ({ ...prev, ContactEmail: false }));
        }}
      />

      {/* <ModalItem
        label="Activation date"
        children={<HighgroundDatePicker
          icon='/images/settings-nav/supplier_and_manufacturers_datepicker.svg'
          className={'d-flex align-items-center radius-4 highlight-input-with-grey-border p-2 w-100'}
          singleDatePicker={true}
          selected={(modalData?.objId_SupplierManufacturer === 0 && !modalData?.ActivationDate) ? getTodayFormatted() :
            modalData?.ActivationDate?.split("T")?.length > 1 ? formatDate(modalData?.ActivationDate)?.split(" ")[0] : modalData?.ActivationDate}
          placeholder={' '}
          isError={errors?.ActivationDate ?? errors?.ActivationDateType}
          errorText={errors?.ActivationDateType && 'Please choose other date'}
          onChange={(e) => {
            setModalData(prev => ({ ...prev, ActivationDate: e ?? '' }))
            setErrors((prev) => ({ ...prev, ActivationDate: false }));
          }}
          id="datepicker-create-task-due-date"
          DropdownClassName={'supplierAndManufacturersDatePicker'}
        />}
      /> */}

      <ModalItem
        label="Activation date"
        children={<HighgroundDatePicker
          icon='/images/settings-nav/supplier_and_manufacturers_datepicker.svg'
          className={'d-flex align-items-center radius-4 highlight-input-with-grey-border p-2 w-100'}
          singleDatePicker={true}
          selected={modalData?.ActivationDate?.split("T")?.length > 1 ? formatDate(modalData?.ActivationDate)?.split(" ")[0] : modalData?.ActivationDate}
          placeholder={' '}
          isError={errors?.ActivationDate ?? errors?.ActivationDateType}
          errorText={errors?.ActivationDateType && 'Please choose other date'}
          onChange={(e) => {
            setModalData(prev => ({ ...prev, ActivationDate: e ?? '' }))
            setErrors((prev) => ({ ...prev, ActivationDate: false }));
          }}
          id="datepicker-create-task-due-date"
          DropdownClassName={'supplierAndManufacturersDatePicker'}
        />}
      />


      <ModalItem
        label="Website"
        value={modalData?.Website}
        placeholder="https://website.com"
        isError={errors?.Website}
        onChange={(value) => {
          setModalData(prev => ({ ...prev, Website: value ?? '' }))
          setErrors((prev) => ({ ...prev, Website: false }));
        }}
      />

      <ModalItem
        label="Category"
        children={<CategoryOrSubcategoryDropdown
          isError={errors?.Category}
          selectedData={modalData?.CategorySelected_List}
          data={categoriesList}
          onItemClick={(category) => {
            if (modalData?.CategorySelected_List) {
              const index = modalData?.CategorySelected_List?.findIndex(item => item?.ObjectId === category?.ObjectId);
              let newData;
              if (index !== -1) {
                newData = modalData?.CategorySelected_List?.filter(item => item?.ObjectId !== category?.ObjectId);
              } else {
                newData = [...modalData?.CategorySelected_List, { ObjectId: category?.ObjectId, Name: category?.CategoryName, Icon: category?.CategoryColour }];
              }

              setModalData(prev => ({ ...prev, CategorySelected_List: newData ?? [] }))
              getProductSubCategories(category?.ObjectId);
            } else {
              setModalData(prev => ({ ...prev, CategorySelected_List: [{ ObjectId: category?.ObjectId, Name: category?.CategoryName, Icon: category?.CategoryColour }] ?? [] }))
              getProductSubCategories(category?.ObjectId);
            }
            setErrors((prev) => ({ ...prev, Category: false }));
          }}
          onCross={(category) => {
            let newData;
            newData = modalData?.CategorySelected_List?.filter(item => item?.ObjectId !== category?.ObjectId);

            setModalData(prev => ({ ...prev, CategorySelected_List: newData ?? [] }))
          }}
        />}
      />

      <ModalItem
        label="Subcategory"
        children={<CategoryOrSubcategoryDropdown
          selectedData={modalData?.SubCategorySelected_List}
          data={subCategoriesList}
          isError={errors?.Subcategory}
          onItemClick={(category) => {
            if (modalData?.SubCategorySelected_List) {
              const index = modalData?.SubCategorySelected_List?.findIndex(item => item?.ObjectId === category?.ObjectId);
              let newData;
              if (index !== -1) {
                newData = modalData?.SubCategorySelected_List?.filter(item => item?.ObjectId !== category?.ObjectId);
              } else {
                newData = [...modalData?.SubCategorySelected_List, { ObjectId: category?.ObjectId, Name: category?.CategoryName, Icon: category?.CategoryColour }];
              }

              setModalData(prev => ({ ...prev, SubCategorySelected_List: newData ?? [] }))
            } else {
              setModalData(prev => ({ ...prev, SubCategorySelected_List: [{ ObjectId: category?.ObjectId, Name: category?.CategoryName, Icon: category?.CategoryColour }] ?? [] }))
            }
            setErrors((prev) => ({ ...prev, Subcategory: false }));
          }}
          onCross={(category) => {
            let newData;
            newData = modalData?.SubCategorySelected_List?.filter(item => item?.ObjectId !== category?.ObjectId);

            setModalData(prev => ({ ...prev, SubCategorySelected_List: [] ?? [] }))
          }}
        />}
      />

      <CompanyLogoInfo icon={modalData?.Icon} uploadRef={uploadRef} />

      <input
        type="file"
        accept=".png,.svg,.jpg"
        onChange={(e) => handleUpload(e)}
        className="d-none"
        ref={uploadRef}
        multiple
      />
    </>
  );
};

export default EditModalBody;

function formatDate(input) {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function getTodayFormatted() {
  const today = new Date();
  console.log('today', today)

  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = today.getFullYear();

  return `${day}/${month}/${year}`;
}

const ModalItem = ({
  label = '',
  children,
  value = '',
  placeholder = '',
  disable = false,
  isError = false,
  errorText,
  onChange = (value) => { }
}) => (
  <div className="bodyModalItem">
    <div className="bodyModalLabel">{label}</div>
    {children ? children : <HighlightInput
      disable={disable}
      value={value}
      placeholder={placeholder}
      isError={isError}
      errorText={errorText ?? `${label} cannot be empty`}
      onChange={(value) => { onChange(value) }}
    />
    }
  </div>
)

const CompanyLogoInfo = ({
  icon,
  uploadRef = null
}) => (
  <div className="companyLogoModalInfo">
    <img
      src={icon ?? '/images/settings-v2/supplier-manufacturer-default-icon.svg'}
      width={48} height={48}
      alt="company logo"
      className="radius-12 mr-3"
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = '/images/settings-v2/supplier-manufacturer-default-icon.svg';
      }}

    />
    <div>
      <div className="label">Logo</div>
      <div className="description">
        We automatically got the company logo <span
          className="link"
          onClick={() => {
            uploadRef.current.click();
          }}
        >
          change
        </span>
      </div>
    </div>
  </div>
)
